import { useEffect, useState } from "react"
import { getApiSettings, updateApiSettings } from "../Services";
import {
  FormControl,
  FormLabel,
  Input,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Button,
  Flex,
  Spacer,
  useBoolean,
  Spinner,
  useToast,
  Box
} from '@chakra-ui/react';
import { BiSave } from 'react-icons/bi';
import { Theme } from "../Theme";

const ApiField = ({ defaultValue, value, field, label, onChange }) =>
  <FormControl mt={2} size={'sm'} style={Theme.FormControl}>
    <FormLabel htmlFor={field} style={Theme.Label}>{label}</FormLabel>
    <Input
      style={Theme.Field}
      name={field}
      defaultValue={defaultValue}
      value={value}
      onChange={(event) => onChange(field, event.target.value)}>
    </Input>
  </FormControl>

const ApiSettings = () => {
  const [configuration, setConfiguration] = useState([]);
  const [form, setForm] = useState();
  const [loader, setLoader] = useBoolean();
  const toast = useToast();

  const onChange = (field, value) => setForm(prevState => ({ ...prevState, [field]: value }))

  const handleSave = () => {
    setLoader.on();
    updateApiSettings(form)
      .then(data => {
        toast({
          position: 'bottom-right',
          status: 'success',
          isClosable: true,
          title : 'Your settings have been successfully saved'
        })
      })
      .catch(error => {
        toast({
          position: 'bottom-right',
          status: 'error',
          isClosable: true,
          title : 'We are sorry, an error occured when saving settings, ' + error.message
        })
      })
      .finally(_ => setLoader.off())
  }

  useEffect(() => {
    getApiSettings()
      .then(data => {
        setConfiguration(data);
      });
  }, [])

  return <>
    <Flex background={'#e9e9e9'} direction={'row'} p={2} alignItems={'flex-end'} justifyContent={'flex-end'}>
      <Button disabled={loader} onClick={handleSave} size={'sm'} colorScheme='blue'>
        {(!loader) ? <BiSave size={20} /> : <Spinner size={'sm'} />}
        <Spacer w={'10px'} />Save settings
      </Button>
    </Flex>
    <Box style={Theme.Container}>
      <Tabs className="bf-admin-tabs" orientation="vertical">
        <TabList className="bf-admin-tab-list">
          {configuration?.map((value, index) => <Tab key={`tabs-apik-${index}`} _selected={Theme.TabVerticalActive} style={Theme.TabVertical}>{value.label}</Tab>)}
        </TabList>
        <TabPanels style={Theme.Panels}>
          {configuration?.map((section, index) =>
            <TabPanel key={`pnl-apik-${index}`} p={0} style={Theme.Panel}>
              {Object.entries(section.data)
                .map((field,index) => {
                  return <ApiField
                    key={`fld-apik-${index}`}
                    field={field[0]}
                    defaultValue={field[1].value}
                    label={field[1].label}
                    onChange={onChange} />
                })}
            </TabPanel>
          )}
        </TabPanels>
      </Tabs>
      {(loader) ? <Flex style={Theme.Loader}><Spinner size={'lg'} /></Flex> : null}
    </Box>
  </>
}

export default ApiSettings